module.exports = __webpack_public_path__ + "img/home.05604f02.png";